import React, { useState, useEffect } from 'react';
import { getAuth, sendEmailVerification, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import './verifyEmailForm.css';
import logoClaro from '../images/Logo.png';
import logoDark from '../img/logoDark.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const VerifyEmailForm = ({ handleTabChange }) => {
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [seconds, setSeconds] = useState(0); // Estado para el contador
  const auth = getAuth();
  const navigate = useNavigate();
  const [logo, setLogo] = useState(logoDark);
  useEffect(() => {
    if (localStorage.getItem('darkMode') === 'true') {
      setLogo(logoDark);
    } else {
      setLogo(logoClaro);
    }
  }, []);
  useEffect(() => {
    if (auth.currentUser) {
      setUserEmail(auth.currentUser.email);
    }
  }, [auth]);

  // Manejador del botón "Reenviar email"
  const handleResendEmail = async () => {

    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        setEmailSent(true);
        setSeconds(10); // Iniciar el contador en 5 segundos
      } catch (error) {
        //console.error('Error al reenviar el correo de verificación:', error);
        toast.error("Hubo un error al enviar el correo de verificación. Intenta de nuevo.");  // Notificación de error
      }
    }
  };

  // Maneja el temporizador que controla el botón
  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);

      return () => clearInterval(interval); // Limpiar intervalo al desmontar
    } else {
      setEmailSent(false); // Habilitar el botón cuando llegue a 0
    }
  }, [seconds]);

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      //navigate('/login'); // Redirigir al login
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <div className="verify-container">
      <ToastContainer />
      <form className="verify-form">
        <img src={logo} alt="logo" className="verify-logo" />
        <br />
        <p className="verify-title">Verifica tu correo electrónico</p>
        <div className="verify-description">
          <p>
            Hemos enviado un enlace de verificación al correo <strong>{userEmail}</strong>.
            Por favor, verifica tu correo y sigue el enlace para confirmar tu cuenta.
          </p>
        </div>

        <p className="verify-warning">Si deseas ser Anfitrión se te habilitará en un máximo de 48 horas</p>

        <button
          type="button"
          className="verify-resend-btn"
          onClick={handleResendEmail}
          disabled={emailSent}
        >
          {emailSent ? `Volver a reenviar en ${seconds}s` : 'Reenviar email de verificación'}
        </button>

        <button className="verify-logout-btn" onClick={handleSignOut}>
          Cerrar sesión
        </button>
      </form>
    </div>

  );
};

export default VerifyEmailForm;
